/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['reset-password{display:block;height:100%;background-color:#fafafa}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvYXV0aC9yZXNldC1wYXNzd29yZC9yZXNldC1wYXNzd29yZC5jb21wb25lbnQuc2Nzcy5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vbW50L2UvYXBwcy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC9hdXRoL3Jlc2V0LXBhc3N3b3JkL3Jlc2V0LXBhc3N3b3JkLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// /mnt/e/apps/helpdesk/client/src/$$_gendir/app/auth/reset-password/reset-password.component.scss.ngstyle.ts